import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link to="/productos" onClick={() => setMenuOpen(false)}>
                Productos
              </Link>
            </li>
          </ul>
        </nav>

        <div className="logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src="https://res.cloudinary.com/dozvtnkeb/image/upload/logosuplymar_amqdde.png" alt="Suplymar Logo" />
          </Link>
        </div>

        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Abrir menú"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}

export default Header;
